<app-banner [heading]="'HOUSE COMPETITIONS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="events3" class="events3">
      <div class="container" data-aos="fade-up">
	  		 <h5><b>Inter House World Science Day Competition  (11/11/2021)<br>
	  <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	 <!-- October -->
	  <h5><b> Salad Competition (16/10/2021)</b><br>
	  <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  </h5><h5> <b>Inter House Dance Competition (09/10/2021)<br>
	  	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>

 <h5><b>Intra House Dance Competition (05/10/2021)</b> <br>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>

<!-- September -->
			</h5><h5><b> Inter House Singing Competition (06/09/2021) </b><br>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  </h5><h5>  <b>Intra House Singing Competition  (01/09/2021) </b> <br>
	  </h5>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
	  <!-- August -->
	 
 <h5> <b> Janmashtami Celebration (28/08/21 ) <br></b></h5><b>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	 
	  <h5> <b>Inter House Quiz Competition (28/08/2021)<br>
 </b></h5><b>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <h5> <b>Inter House Calligraphy Competition (25/08/2021)<br></b></h5><b>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
	  <h5> <b>Rakhi Making Competition (21/08/2021)<br>
</b></h5><b>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (11).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  <h5><b>Intra House Quiz Competition (19/08/2021) <br>
	  
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (12).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (13).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  <h5><b> Intra House Calligraphy Competition (18/08/2021) <br>
	  <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (15).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (16).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <h5> <b>Bangle Decoration Competition (11/08/2021) <br>
	  </b></h5><b>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div> 	
	  <h5><b>Mehndi Decoration Competition (11/08/2021) <br></b></h5><b>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (19).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div> 	
	  <h5> <b>Intra House Declamation Competition  (10/08/2021)<br></b></h5><b>
		<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (21).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (22).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (23).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <!-- August -->
	  <!-- July -->
	<h5><b> Inter House Creative Writing  Competition (29/07/2021)<br>
	</b></h5><b>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Inter House Extempore Competition (28/07/2021)<br></b></h5><b>
	<div class="row">
		<!--<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (2).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House No Stove Cooking Competition (17/07/2021)</b><br></h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  
	</div>
	<h5><b> Intra House Creative Writing Competition (10/07/2021)</b><br></h5> 
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>	
	<h5><b> Intra House Extempore Competition (05/07/2021)</b><br> </h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (11).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House Bag Making Competition (03/07/2021) <br>
	</b></h5><b>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (14).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (15).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House First-Aid Box Making Competition (01/07/2021) <br>
	
	<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (19).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	</div>
	 
		


	 <!-- May -->
	<h5> <b>	Inter House Yoga Competition  (28/05/2021) <br> </b></h5><b>
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (1).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		 </div>
	<h5> <b>Inter House Story Weaving Competition  (25/05/2021) <br> 
					
					</b></h5><b>
		<div class="row">
           <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (11).jpg" alt="best school in kurukshetra">
            </div>
          </div> 
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
-->
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (7).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>-->
		  </div>
		
		  		
		<h5><b>Intra House Yoga Competition  (05/05/2021)<br> 

          <div class="row">
<!--          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (16).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (15).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (14).jpg" alt="best school in kurukshetra">
            </div>
          </div>

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (13).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (12).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
		<h5><b> Intra House Story Telling Competition (03/05/2021)</b><br>

          <div class="row">

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
        
		 </h5><h5> <b> Inter House Art Competition ( Best out of waste) (29/04/2021)</b><br>
				   
         <div class="row"> 
		  <!--<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (25).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (24).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (23).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	-->
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (22).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (21).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (19).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		</div> 

		 </h5><h5> <b> Inter House Slogan Writing Competition on Earth Day  (22/04/2021) </b> <br>
				
				</h5>
         <div class="row">
         <!-- <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (29).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (28).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (27).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (26).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		</div>
 <h5> <b>Intra House Poster Making Competition  (15/04/2021) </b><br>
	
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (33).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (32).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (31).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	-->

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (30).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
		 </h5><h5><b>Healthy Tiffin Box Competition   (07/04/2021)</b></h5>
						   
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (38).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (37).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (36).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (35).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (34).jpg" alt="best school in kurukshetra">
            </div>
          </div>-->
		</div>
		
		<div> <h5><b>Inter House Art Competition  (03/04/2021)</b></h5>
		</div>
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (41).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (40).jpg" alt="best school in kurukshetra">
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (39).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
			
		
		 
          
		</b></h5></b></b></b></h5></b></b></b></b></b></b></b></h5></b></h5></b></b></b></b></b></h5></b></h5></div><b><b>
      
	</b></b></section><!-- End About Section --><b><b>
	
	
    

	
	
    
    
  </b></b></main>